let copy = function(data: any) {
  let cp = {};
  if (data) {
    /* tslint:disable */
    for (let key in data) {
      cp[key] = data[key];
    }
    /* tslint:enable */
  }
  return cp;
};

export const Utils = {
  copy: copy
};



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/utils.service.ts